import { Icon } from "@minted/minted-components";
import PropTypes from "prop-types";
import React from "react";

const editButtonStyle = {
  alignItems: "center",
  backgroundColor: "#ffffff",
  borderRadius: "50%",
  boxShadow: "0 0 3px rgba(0,0,0,.5)",
  color: "#333333",
  cursor: "pointer",
  display: "flex",
  fontSize: "25px",
  height: "50px",
  justifyContent: "center",
  lineHeight: 1,
  textAlign: "center",
  width: "50px",
  zIndex: 999,
};

const EditableImageAsset = ({ assetSpec, onEdit, position }) => {
  if (!position) {
    return null;
  }
  const offset = 15;
  const style = {
    left: `${position.left - 50 - offset}px`,
    position: "absolute",
    top: `${position.top + offset}px`,
  };

  return (
    <div css={style}>
      <div css={editButtonStyle} onClick={() => onEdit(assetSpec)}>
        <Icon type={Icon.types.editSquare} />
      </div>
    </div>
  );
};

const imageAssetSpec = PropTypes.shape({
  algorithm: PropTypes.oneOf(["crop"]),
  height: PropTypes.number.isRequired,
  key: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
});

const position = PropTypes.shape({
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
});

EditableImageAsset.propTypes = {
  assetSpec: imageAssetSpec.isRequired,
  onEdit: PropTypes.func.isRequired,
  position: position.isRequired,
};

export default EditableImageAsset;
